import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { usePaystackPayment } from 'react-paystack';
import Instruction from './Instruction';
import { ContextData } from '../../../../../../../context/Context';



export default function UploadForm(props) {




 const {readStatus} = React.useContext(ContextData)


 const initializePayment = usePaystackPayment(
  {
  publicKey: 'pk_test_2d7288cff5bfe0819aeaa8aa60f40494d0361e7b',
  reference: (new Date()).getTime().toString(),
  email: "test@mui.com",
  amount: 1000,
  firstname:  "test",
  lastname: "test",
   },
   
   )



    // Handle on success after payment
    const onSuccess = (reference) => {
      // Implementation for whatever you want to do with reference and after success call.
      // SubmitFormdata()
    // console.log(formData)
   
    };
  
// Handle close if no succeeded payment
 const onClose = () => {
  // implementation for  whatever you want to do when the Paystack dialog closed.
  console.log('closed')
  
  
}
    
  

 const HandlPaymentCall = ()=>{


       // Call Payment Getway if not empty
      initializePayment(onSuccess,onClose)

 }


// disabled={readStatus}
  return (
  
            <TableRow
              
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
            
              <TableCell align="center">{props.data.scholarship_name.toUpperCase()}</TableCell>

              <TableCell align="center">{props.data.scholarship_type.toUpperCase()} SCHOLARSHIP</TableCell>
 
              {/*  <TableCell align="center">  
                <Instruction/>
               </TableCell> */}

               <TableCell align="center"> 

               <Instruction 
               
               type="instrct_apply"
               value={props.data.scholarship_description}
               scholarship_applied = {props.data.scholarship_name}
               scholarship_type = {props.data.scholarship_type}
               schl_token = {props.data.schl_token}
               user_token = {props.user_token}
               setOpenLoader = {props.setOpenLoader}
                
                />


               </TableCell>

            {/*   <TableCell align="center" title='Read before apply and click aggree button it would enable the Apply button' >
              <Button onClick={HandlPaymentCall} className='Hover-'  elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(0, 24, 69)', color:"white", margin:'9px 4px',fontWeight:"800"}}  size="medium" variant="contained">
               <LaunchIcon sx={{fontSize:"1.6em",marginRight:"2px"}} />  Apply
               </Button>
              </TableCell>
 */}


            </TableRow>
 
 
  );
}